import { createContext } from 'react';

import type { CombinedNotificationsResponse } from '~/shared/hooks/useCombinedNotifications';

const CombinedNotificationsContext = createContext<CombinedNotificationsResponse>({
  combinedNotificationsResponse: undefined,
});

export default CombinedNotificationsContext;
